import { onMounted, onUnmounted } from 'vue';
import userTools from '@/tools/userTools.js';
import Cookies from "js-cookie";

// On utilise une promesse pour suivre l'état d'initialisation.
// Cela permet d'attendre la fin du chargement du script.
let chatReadyPromise = null;
let openChatFunction = null;

const initialize = () => {
    if (chatReadyPromise) return;

    chatReadyPromise = new Promise(async (resolve, reject) => {
        const initialGlobals = new Set(Object.keys(window));
        
        let visitorPayload = {
            email: 'visiteur@kernel.com',
            name: 'Visiteur'
        };

        try {
            const token = Cookies.get('token');
            if (token) {
                const userInfo = await userTools.getUserMainInformations(token);
                if (userInfo) {
                    visitorPayload = {
                        email: userInfo.email || 'email-non-fourni@kernel.com',
                        name: userInfo.fullName || 'Client Kernel'
                    };
                }
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des informations utilisateur pour le chat:", error);
        }

        window.KernelChatConfig = {
          widgetCode: 'BE85F3C8',
          apiUrl: 'https://crmkernel.netlify.app/.netlify/functions',
          settings: {
            primaryColor: 'rgb(148, 228, 175)',
            position: 'bottom-right',
            greeting: "En quoi pouvons nous vous aider aujourd'hui ?",
            placeholder: 'Tapez votre message...'
          },
          visitor: visitorPayload
        };
        
        const script = document.createElement('script');
        script.id = 'kernel-chat-v2-script';
        script.src = 'https://crmkernel.netlify.app/chat-widget-v2.js?v=' + Date.now();
        script.async = true;

        script.onload = () => {
            const finalGlobals = Object.keys(window);
            // On filtre pour trouver les nouveaux objets, en excluant celui que nous avons créé.
            const newGlobalKeys = finalGlobals.filter(key => !initialGlobals.has(key) && key !== 'KernelChatConfig'); 
            
            console.log("Nouveaux objets globaux (après filtrage) :", newGlobalKeys);

            if (newGlobalKeys.length === 0) {
                 if (window.KernelChat) {
                     console.log("Aucun nouveau global, mais window.KernelChat existe. Propriétés :", Object.keys(window.KernelChat));
                 }
                 return reject("Le script n'a ajouté aucun nouvel objet global pertinent. Impossible de trouver l'API.");
            }

            // On prend le premier nouvel objet global comme étant l'API.
            const apiObjectKey = newGlobalKeys[0];
            const api = window[apiObjectKey];

            console.log(`Hypothèse : l'API est sur window.${apiObjectKey}. Contenu :`, api);

            if (api && typeof api.open === 'function') {
                openChatFunction = api.open.bind(api);
                resolve();
            } else if (api && typeof api.toggle === 'function') {
                openChatFunction = api.toggle.bind(api);
                resolve();
            } else if (api && typeof api.show === 'function') {
                openChatFunction = api.show.bind(api);
                resolve();
            }
            else {
                reject(`L'objet API 'window.${apiObjectKey}' ne semble pas avoir de fonction 'open', 'toggle' ou 'show'.`);
            }
        };

        script.onerror = () => reject("Le script du widget de chat n'a pas pu être chargé.");

        document.head.appendChild(script);
    });
};

const cleanup = () => {
    const script = document.getElementById('kernel-chat-v2-script');
    if (script) script.remove();
    
    const widget = document.getElementById('kernel-chat-widget');
    if (widget) widget.remove();

    if (window.KernelChatConfig) delete window.KernelChatConfig;
    // On ne peut pas facilement supprimer la variable globale car on ne connait pas son nom à l'avance
    
    chatReadyPromise = null;
    openChatFunction = null;
};

export function useChat() {
    
    const initializeChat = () => {
        onMounted(initialize);
        onUnmounted(cleanup);
    };

    const openChat = async () => {
        if (!chatReadyPromise) {
            console.error("Le chat n'est pas en cours d'initialisation. Appelez initializeChat() dans le layout principal.");
            return;
        }

        try {
            await chatReadyPromise;
            if (openChatFunction) {
                openChatFunction();
            } else {
                console.error("La fonction d'ouverture du chat n'est pas disponible.");
            }
        } catch (error) {
             console.error("Erreur lors de l'ouverture du chat :", error);
        }
    };

    return { initializeChat, openChat };
} 